import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./Products.css";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import ipm1 from "../assets/images/RatchetBelt1.jpg";
import ipm2 from "../assets/images/RatchetBelt2.jpg";
// import ipm3 from "../assets/images/ipm-3.webp";
// import ipm3 from "../assets/images/ipm-2.jpeg";
import ipm3 from "../assets/images/RatchetBelt.jpg";

import ipm4 from "../assets/images/PPPartition.webp";
// import ipm5 from "../assets/images/ipm-5.jpg";Silica Gel Packets

import silicaGelPackets from "../assets/images/ipm-6.jpg";
import ipm5 from "../assets/images/PPSheet&PPBox.webp";
import ipm6 from "../assets/images/PPSheet.webp";
// import ms1  from "../assets/images/manufacture & supply-1.jpg";
import ms1 from "../assets/images/InjectionMouldedPallet.jpg"
// import ms2  from "../assets/images/manufacture & supply-2.jpg";
import ms2  from "../assets/images/FLCBoxPallet.avif";
import ms3  from "../assets/images/ExportPallet.jpg";
import foamFitment  from "../assets/images/customized-epe-foam-fitment.jpg";
import foamFitment1 from "../assets/images/customized-epe-foam-fitment1.jpg";
import foamTray     from "../assets/images/customized-epe-foam-tray.jpg";
import evaFoam      from "../assets/images/customized-eva-packaging-foam.jpg";
import hdFoamTray   from "../assets/images/customized-high-density-foam-tray.jpg";
import hdFoam       from "../assets/images/customized-high-density-packaging-foam.jpg";
import packFitment  from "../assets/images/customized-packaging-foam-fitment.jpg";
import selfAdhesive from "../assets/images/customized-self-adhesive-foam-tape.jpg";
import epeGasket    from "../assets/images/epe-foam-gasket1.jpg";
import epeProfile   from "../assets/images/epe-foam-profile.jpg";
import foamCorner   from "../assets/images/foam-corner-profile1.jpg";
import foamFab      from "../assets/images/foam-fabricated-parts.jpg";
import puGasket     from "../assets/images/pu-foam-gasket.jpg";
import puProfile    from "../assets/images/pu-profile-foam.jpg";
import whiteBracket from "../assets/images/white-epe-foam-bracket.jpg";
import StretchFilmBubbleRoll from "../assets/images/Stretch Film & Bubble Roll.jpg";
import AngleBoard from "../assets/images/AngleBoard.jpg";
import CornerProtector from "../assets/images/CornerProtector.jpg";
import PETStrap from "../assets/images/PP&PETStrap.avif"

import CompositeCordStrap from "../assets/images/CompositeCordStrap.jpg";
import BoxStrappingMachine from "../assets/images/BoxStrappingMachine.jpg";
import ProtectiveSleeves from "../assets/images/ProtectiveSleeves.jpg";
import MeshSleeves from "../assets/images/MeshSleeves.jpg";
import FoamSleeves from "../assets/images/FoamSleeves.jpg";
import DesiccantSilicaGel from "../assets/images/DesiccantSilicaGel.jpg";
import stretchfilmrollspackaging from "../assets/images/stretch-filmrolls-packaging.jpg";
import airbubblerollsandpackaging from "../assets/images/air-bubblerolls-and-packaging.jpg"
import BOPPTapePrintedTape from "../assets/images/manufacture & supply-1.jpg";
import CorrugatedPackagingMaterials from "../assets/images/Corrugated Packaging Materials.jpeg";
import PPPETStrap from "../assets/images/PP&PETStrap.avif";
import BoxesPallets from "../assets/images/BoxesPallets.jpg"

const products = [
  { title: "Stretch Film",               description: "High-quality stretch films for wrapping and securing pallets during transit.", image: stretchfilmrollspackaging },
  { title: "Air Bubble Roll & Foam Sheet",description: "Protective air bubble rolls and foam sheet rolls for safe, cushioned packaging.", image: airbubblerollsandpackaging },
  { title: "BOPP Tape & Printed Tape",   description: "Durable BOPP tapes, printed tapes, floor marking tape, duck tape, and masking tape.", image: BOPPTapePrintedTape },
  { title: "Corrugated Box & Roll",      description: "Strong corrugated boxes and rolls for industrial and commercial packaging use.", image: CorrugatedPackagingMaterials },
  { title: "PP & PET Strap",             description: "Reliable PP and PET strapping for bundling and securing heavy industrial loads.", image: PPPETStrap },
  { title: "Silica gel and desiccant packaging materials ",        description: "Silica gel and desiccant packaging materials protect products from moisture damage.", image: DesiccantSilicaGel },
];

/* Every category has exactly 3 images */
const categoryData = {
  "Stretch Film": [
    { name: "Stretch Film Roll",       image: stretchfilmrollspackaging  },
    { name: "Pallet Wrap Film",        image: BoxesPallets },
    { name: "Stretch Film & Bubble Roll",        image: StretchFilmBubbleRoll },
  ],
  "Foam Sheet Roll": [
    { name: "EPE Foam Fitment",   image: foamFitment  },
    { name: "EPE Foam Fitment 2", image: foamFitment1 },
    { name: "EPE Foam Tray",      image: foamTray     },
    { name: "EVA Packaging Foam", image: evaFoam      },
    { name: "HD Foam Tray",       image: hdFoamTray   },
    { name: "HD Packaging Foam",  image: hdFoam       },
  ],
  "Customized Foam Products": [
    { name: "Packaging Foam Fitment",  image: packFitment  },
    { name: "Self Adhesive Foam Tape", image: selfAdhesive },
    // { name: "EPE Foam Gasket",         image: epeGasket    },
    { name: "EPE Foam Profile",        image: epeProfile   },
    { name: "Foam Corner Profile",     image: foamCorner   },
    { name: "Foam Fabricated Parts",   image: foamFab      },
  ],
  "PU Foam Products": [
    // { name: "PU Foam Gasket",        image: puGasket     },
    { name: "Convoluted PU Foam (Egg Crate)",       image: puProfile    },
    { name: "White EPE Foam Bracket",image: whiteBracket },
  ],
  "Dunnage Air Bag": [
    { name: "Dunnage Air Bag",    image: ms3  },
    // { name: "Cargo Protection",   image: ipm6 },
    // { name: "Air Bag Packaging",  image: ms1  },
  ],
  "Silica Gel": [
    { name: "Silica Gel Packets",  image: silicaGelPackets },
    { name: "Desiccant Silica Gel",image: DesiccantSilicaGel },
  ],
  "Ratchet Belt / Lashing Belt": [
    { name: "Ratchet Belt",       image: ipm3 },
    { name: "Cargo Lashing Belt", image: ipm2 },
    { name: "Truck Lashing Strap",image: ipm1 },
  ],
  "FLC Box Pallet": [
    { name: "FLC Box Pallet",          image: ms2  },
    { name: "Injection Moulded Pallet",image: ms1  },
    { name: "Export Pallet",           image: ms3  },
  ],
  "PP Sheet & PP Box": [
    { name: "PP Sheet",    image: ipm6 },
    { name: "PP Box",      image: ipm5 },
    { name: "PP Partition",image: ipm4 },
  ],
  "Angle & Edge Board": [
    { name: "Angle Board",      image: AngleBoard },
    { name: "Corner Protector", image: CornerProtector },
  ],
  "Composite Cord Strap": [
    { name: "Composite Cord Strap", image: CompositeCordStrap },
    { name: "PP & PET Strap",       image: PETStrap },
  ],
  "Box Strapping Machine": [
    { name: "Box Strapping Machine", image: BoxStrappingMachine  },
  ],
  "Protective Sleeves": [
    { name: "Protective Sleeves", image: ProtectiveSleeves  },
    { name: "Mesh Sleeves",       image: MeshSleeves },
    { name: "Foam Sleeves",       image: FoamSleeves },
  ],
};

const categories = Object.keys(categoryData);

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => { AOS.init({ duration: 800, once: true }); }, []);

  return (
    <div className="products-page">
      {/* Page Hero */}
      <div className="page-hero">
        <div className="page-hero-content">
          <h1 data-aos="fade-up">Our Industrial Packaging Products</h1>
          <p data-aos="fade-up" data-aos-delay="100">
            Complete range of packaging materials — manufactured and supplied across Pune and India
          </p>
        </div>
      </div>

      <Container className="mt-5 pt-2">
        {/* Product Grid */}
        <h2 className="rotating-yellow-text text-center" data-aos="fade-up">Product Range</h2>
        <Row className="mt-4">
          {products.map((product, index) => (
            <Col md={4} sm={6} key={index} className="mb-4 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay={index * 80}>
              <Card className="product-card text-center">
                <div className="card-image-wrap">
                  <img src={product.image} alt={product.title} />
                </div>
                <Card.Body>
                  <Card.Title>{product.title}</Card.Title>
                  <Card.Text>{product.description}</Card.Text>
                  <Button as={Link} to="/material">View Details</Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Category Browser */}
        <h2 className="rotating-yellow-text text-center mt-4" data-aos="fade-up">Browse by Category</h2>
        <p className="text-center mb-3" style={{ color: "#4A7FA7", fontFamily: "Poppins", fontSize: "0.95rem" }} data-aos="fade-up">
          Select a category from the sidebar to explore our products
        </p>

        <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
          {sidebarOpen ? "Hide Categories ✕" : "☰ Show Categories"}
        </button>

        <div className="products-container">
          {/* Sidebar */}
          <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
            {categories.map((category, index) => (
              <div
                key={index}
                className={`sidebar-item ${selectedCategory === category ? "active" : ""}`}
                onClick={() => { setSelectedCategory(category); setSidebarOpen(false); }}
              >
                {category}
              </div>
            ))}
          </div>

          {/* Main Content */}
          <div className="main-content">
            <div className="cat-header">
              <h2 className="category-title">{selectedCategory}</h2>
              <span className="cat-count">{categoryData[selectedCategory].length} products</span>
            </div>
            <div className="drawer-gallery">
              {categoryData[selectedCategory].map((item, index) => (
                <div key={index} className="drawer-item" data-aos="zoom-in" data-aos-delay={index * 60}>
                  <img src={item.image} alt={item.name} />
                  <div className="drawer-label">{item.name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Products;
